<template>
	<div class="SHPiao">
		
		<div class="content">
			<!-- <div class="title">
        <p style=" font-size: 16px; padding: 0; margin: 0;">浏览调拨单</p>
      </div> -->
			<div class="content-header">
				<div class="title-list"></div>
			</div>
			<PrintView v-show="0" ref="deftemp" style="z-index: 99; position: absolute"></PrintView>
			<div class="center-box">
				<div class="center-top">
					<ul class="rowitem">
						<li class="inputitem">
							<div style="float: right">
								<VsDatePicker width="150" v-model="infolist.StartTime" lable="起始日期"></VsDatePicker>
							</div>
						</li>

						<li class="inputitem">
							<div style="float: right">
								<VsDatePicker width="150" v-model="infolist.EndTime" lable="结束日期"></VsDatePicker>
							</div>
						</li>
						<li class="inputitem">
							<div style="float: right; margin-top: 5px">
								<InputSelectCKAuth lable="调出仓库" width="150" returnkey="CKID" v-model="infolist.OutCKID">
								</InputSelectCKAuth>
							</div>
						</li>
						<li class="inputitem">
							<div style="float: right">
								<InputFDSelect lable="店铺信息" width="150" returnkey="FDID" v-model="infolist.FDID"
									@on-select="SendFDid"></InputFDSelect>
							</div>
						</li>
						<li class="inputitem">
							<div style="float: right; margin-top: 5px">
								<InputSelectCK lable="调入仓库" width="150" returnkey="CKID" v-model="infolist.InCKID">
								</InputSelectCK>
							</div>
						</li>
						<li class="inputitem">
							<div style="float: right">
								<Vsinput v-model="infolist.SerialNo" lable="单据编号" width="150"></Vsinput>
							</div>
						</li>
						<li class="inputitem">
							<div style="float: right">
								<InputCZYSelect lable="操作员" width="150" v-model="infolist.Operator"
									returnkey="UserName"></InputCZYSelect>
							</div>
						</li>
						<li class="inputitem">
							<div style="float: right">
								<Vsinput v-model="infolist.CommonLogistics" lable="物流" width="150"></Vsinput>
							</div>
						</li>
						<li class="inputitem">
							<div style="float: right">
								<VsSelect lable="状态" remote v-model="infolist.IsCheck" :loopdata="seanloopdata"
									:keys="['name']" width="150"></VsSelect>
							</div>
						</li>
						<li class="inputitem">
							<div style="float: right">
								<InputYGSelect lable="仓管员" width="150" v-model="infolist.Leader" returnkey="ZGID">
								</InputYGSelect>
							</div>
						</li>

						<li class="inputitem">
							<div style="float: right">
								<Vsinput v-model="infolist.Remarks" lable="摘要" width="150"></Vsinput>
							</div>
						</li>
								<li class="inputitem">
									</li>
											<li class="inputitem">
												</li>
						<li class="inputitem" style="text-align: right;">
							<vxe-button v-if="cxBtnFlag" type="primary" @click="fnSerchXStables(true)" style="
                  margin-top: 0px;
                  
                  background: #2d8cf0;
                  color: #fff;
                  width: 80px;
                ">
								查询</vxe-button>
							<vxe-button type="primary" v-else @click="btnAuth" style="
                  margin-top: 0px;
        
                  background: #2d8cf0;
                  color: #fff;
                  width: 80px;
                ">
								查询</vxe-button>
						</li>
						<li class="inputitem">
							<div style="
							  display: flex;
							  justify-content: flex-end;
							  align-items: center;
							">
														<vxe-toolbar style=" height: 35px !important; " id="toolbar_dem1"
															:resizable="{ storage: true }" :setting="{ storage: true }">
															<template slot="tools">
																<vxe-button v-if="shBtnFlag" @click="fnState" style="
							        color: #fff;
							        padding: 0px 30px;
							        background: #2d8cf0;
							        
							        width: 80px;
							      ">
																	审核</vxe-button>
																<vxe-button v-else @click="btnAuth" style="
							        color: #fff;
							        padding: 0px 30px;
							        background: #2d8cf0;
							        
							        width: 80px;
							      ">
																	审核</vxe-button>
																	<vxe-button @click="fnFState" v-if="shBtnFlag"
																			style="background: #2d8cf0; color: #fff; width: 80px">反审核</vxe-button>
																		<vxe-button @click="btnAuth" v-else
																			style="background: #2d8cf0; color: #fff; width: 80px">反审核</vxe-button>
																	
															</template>
															
														</vxe-toolbar>
													</div>
							</li>
					</ul>
				</div>
				<div class="center-table">
					<div class="table-wrap">
						
						<div style="flex: 1">
							<vxe-table border height="100%" show-overflow row-id="id" highlight-hover-row
								highlight-current-row highlight-hover-column highlight-current-column ref="xTable"
								:checkbox-config="{ reserve: true }" :data="tableData" @radio-change="radioChangeEvent"
								:header-cell-style="{
                 background: '#1d68df',
                 color: '#fff',
                  borderRight: '1px solid #ccc',
                  fontSize: '14px',
                }" :cell-style="{ fontSize: '12px' }" align="center" size="mini" resizable
				:row-style='rowStyle'
				:seq-config="{ startIndex:(tablePage.pageNum -1 ) * tablePage.pageSize }"
				>
								<vxe-table-column type="radio" width="50" fixed="left">
									<template v-slot:header>
										<vxe-button type="text" @click="clearRadioRowEevnt" :disabled="!selectRow">取消
										</vxe-button>
									</template>
								</vxe-table-column>
								<vxe-table-column type="seq" width="50" title="序号" fixed="left"></vxe-table-column>
								<vxe-table-column field="RecordTime" title="调拨日期" width="120" fixed="left"
									:formatter="formatTime">
								</vxe-table-column>

								<vxe-table-column field="SerialNo" title="单据编号" width="200">
									<template v-slot="{ row }">
										<TheTableDetail :info="row" :oktype="BPtype"  @toPrint="(a, b) => toPrint(a, b)">
											<div slot="title">
												<a>{{ row.SerialNo }}</a>
											</div>
										</TheTableDetail>
									</template>
								</vxe-table-column>

								<vxe-table-column field="IsCheck" title="执行状态" width="120">
									<template v-slot="{ row }">
										<span v-if="row.IsCheck == 0 && row.IsDelete == 0"
											style="color: #25ab23">未审核</span>
										<span v-if="row.IsDelete == 1 && row.IsCheck == 0"
											style="color: #25ab23">已作废</span>
										<span v-if="row.IsCheck == 2" style="color: #0085c8">已完成</span>
									</template>
								</vxe-table-column>
								<vxe-table-column field="OutCKMC" title="调出仓库" width="120" resizable></vxe-table-column>
								<vxe-table-column field="InCKMC" title="调入仓库" width="120" resizable></vxe-table-column>
								<vxe-table-column field="Num" title="数量" width="120"></vxe-table-column>
								<vxe-table-column field="Total" title="金额" width="120"></vxe-table-column>
								<vxe-table-column field="Leader" title="仓管员" width="120"></vxe-table-column>
								<vxe-table-column field="CheckMan" title="审批人" width="120"></vxe-table-column>
								<vxe-table-column field="Operator" title="操作人" width="120"></vxe-table-column>
								<vxe-table-column field="WareHouse" title="配货员" width="120"></vxe-table-column>
								<vxe-table-column field="CommonLogistics" title="发货物流" width="120" resizable>
								</vxe-table-column>
								<vxe-table-column field="Remarks" title="摘要" width="120" resizable></vxe-table-column>
								<vxe-table-column title="作废" width="150" v-slot="{ row }">
									<vxe-button icon="vxe-icon--question" @click="abandon(row)"
										v-if="row.IsDelete == 0 && row.IsCheck == 0">
										作废</vxe-button>
								</vxe-table-column>
							</vxe-table>
						</div>
					</div>
				</div>
				<div class="content-bottom">
					<vxe-pager border size="medium" :current-page="tablePage.pageNum" :page-size="tablePage.pageSize"
						:page-sizes="page_sizes"
						:total="tablePage.totalResult" :layouts="[
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'FullJump',
              'Sizes',
              'Total',
            ]" @page-change="handlePageChange">
					</vxe-pager><span style="width:50px">&nbsp;</span>总数量:<span style="color:green;font-size:16px">{{totalNum}}</span>&nbsp;&nbsp;总金额:<span style="color:green;font-size:16px">{{totalSum}}</span>
					
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import InputYGSelect from "../../components/InputYGSelect.vue";
	import InputPHSelect from "../../components/InputPHSelect.vue";
	import InputCKSelect from "../../components/InputCKSelect.vue";
	import InputCZYSelect from "../../components/InputCCYSelect.vue";

	import TheTableDetail from "./components/TheDBtablesDetail.vue"; // 调拨单详情
	import InputSelectCKAuth from "../../components/InputSelectCKAuth.vue"; // 调出仓库
	import InputFDSelect from "../../components/InputFDSelect.vue"; // 店铺信息
	import InputSelectCK from "./components/InputSelectCK.vue"; // 调入仓库
	// 打印组件
	import PrintView from  "../SetSystem/deftemp_DB.vue";
	import {
		mapState,
		mapActions
	} from "vuex";
	export default {
		components: {
			InputYGSelect,
			InputCKSelect,
			TheTableDetail,
			InputPHSelect,
			InputCZYSelect,
			InputSelectCKAuth,
			InputFDSelect,
			InputSelectCK,
			PrintView
		},
		computed: {
			...mapState({
				FDid: 'FDid'
			})
		},
		data() {
			return {
				
				info: [],
				modelshow: false,
				tablePage: {
					pageNum: 1,
					pageSize: 50,
					totalResult: 0,
				},
				page_sizes: [50, 100, 150, 200, 300, 500],
				seanloopdata: [{
						name: "已验收"
					},
					{
						name: "已完成"
					},
					{
						name: "未审核"
					},
					{
						name: "已作废"
					},
				],
				tableData: [{
					zt: {},
				}],
				infolist: {
					FDID: '', // 分店ID

					InCKID: "", // 入库ID
					SerialNo: "", // 序列号
					OutCKID: "", // 出库ID
					StartTime: this.$fun.GetCurrentDay(), //	 起始日期
					EndTime: this.$fun.GetCurrentDay(), // 结束日期
					Leader: "", // 仓管
					CheckMan: "", // 审批人
					WareHouse: "", // 配货人
					Operator: "", //	 操作员
					Remarks: "", // 	摘要
					CommonLogistics: "", // 物流
					IsCheck: "", // 不填时全部
				},
				selectRow: null,
				abandonInfo: {
					FieldValue: "",
					SerialNo: "",
				},

				zjBtnFlag: false, //增加
				xgBtnFlag: false, //修改
				cxBtnFlag: false, //搜索
				dyBtnFlag: false, //打印
				scBtnFlag: false, //删除
                shBtnFlag: false, //审核
				datee: "2020-07-17",
				BPtype: false,
				totalNum:0,
				totalSum:0,
			};
		},
		mounted() {
			if (this.$fun.Getlocal("Info")[0].IsClothes == 1) {
				this.BPtype = true;
			} else {
				this.BPtype = false;
			}
			this.fnSerchXStables(true); //初始化调拨单列表---默认当天

			// 获取用户权限
			let fliterAuthlist = []
			let AuthUserList = this.$fun.Getlocal('AuthUserList')
			eval(AuthUserList).forEach((item) => {
				item.Subdirectories.forEach((newitem) => {
					if (newitem.Id == "P0402") {
						fliterAuthlist.push(newitem)
					}
				})
				fliterAuthlist.forEach((item) => {
					this.zjBtnFlag = item.zj
					this.cxBtnFlag = item.cx
					this.xgBtnFlag = item.xg
					this.scBtnFlag = item.sc
					this.dyBtnFlag = item.dy
					this.shBtnFlag = item.sh
				})
			})
		},
		methods: {
			rowStyle({ row, rowIndex })
			 {
				
				if (rowIndex%2==1) {
					return {
						backgroundColor: '#f2f2f2'
					}
				}
			 
				if (rowIndex%2==0) {
					return {
						backgroundColor: '#ffffff'
					}
				}
			},
			btnAuth() {
				this.$Message.error('您没有此权限,看看别的叭~')
			},
			// 打印  获取默认模板
			toPrint(item, temp) {
				let user_info = this.$fun.GetUserConstant();
				this.$Api.temp_get_list({
					LB: "DB",
					...user_info
				}).then((res) => {
					let {
						data,
						status
					} = res;
					if (status == "SUCCESS") {
						let def_temp = data.filter((i) => i.Def == 1);
						if (!def_temp.length) {
							this.$Message.error("请选择默认模板");
							return;
						}
						this.$refs.deftemp.toPrint(item, def_temp[0]);
					}
				});
			},
			

			//  分店id存储到vuex的store
			SendFDid() {
				this.$store.commit('SyncUpdateFDid', this.infolist.FDID)
			},

			// rowStyle() {
			// 	return {
			// 		backgroundColor: "#ccc",
			// 	};
			// },

			fnSerchXStables(s) {
				if (this.infolist.StartTime > this.infolist.EndTime) {
					this.$Message.error("起始日期大于结束日期请重新选择！！");
					this.tableData = [];
					return;
				}
				//console.log(this.infolist)
				let num = JSON.parse(localStorage.getItem("overall"))[0].Proper;
				let num1 = JSON.parse(localStorage.getItem("overall"))[25].Proper
				let all=JSON.parse(localStorage.getItem("overall"));
				all.forEach(item=>{
					if(item.Marker=="Accuracy")
					{
						num=item.Proper
						
					}
					
					if(item.Marker=="Precision")
					{
						num1=item.Proper
					}
				});
				let userinfo = this.$fun.GetUserConstant();
				let params = Object.assign({}, userinfo, this.infolist);
				if (s) {
					params.PageNo = 1;
					this.tablePage.pageNum = 1;
				} else {
					params.PageNo = this.tablePage.pageNum;
				}
				if (params.IsCheck == "已作废") {
					params.IsCheck = "-1";
				} else if (params.IsCheck == "未审核") {
					params.IsCheck = "0";
				} else if (params.IsCheck == "已验收") {
					params.IsCheck = "1";
				} else if (params.IsCheck == "已完成") {
					params.IsCheck = "2";
				} else if (params.IsCheck == "") {
					params.IsCheck = "";
				}
				let khinp = document
					.querySelector(".rowitem")
					.querySelectorAll(".inputitem");
				// for(var i=2;i<khinp.length;i++){
				// 		khinp[i].querySelector('input').value = ''

				// }
				// params.PageNo=this.tablePage.pageNum
				params.PageSize = this.tablePage.pageSize;
				this.getsum(params,num1,num);
				return new Promise((resolve) => {
					setTimeout(() => {
						this.$Api.ErpCKTablesView(params).then((res) => {
							if (res.status == "SUCCESS") {
								this.tablePage.totalResult = res.data.Total;
								res.data.data.page.forEach((item) => {
									item.Total = item.Total.toFixed(num);
									item.Num =item.Num.toFixed(num1);
								});
								this.tableData = res.data.data.page;
								resolve();
					
							}
						});
						
					}, 1);
				});
			},

           getsum(params,num1,num){
			  
			   this.$Api.ErpCKTablesSumView(params).then((res) => {
				   debugger
			   	if (res.status == "SUCCESS") {
					
			         let t= res.data.info;
			   		  if(t.length>0)
			   		  {									  
			   			  this.totalNum=t[0].Num.toFixed(num1);
			   			  this.totalSum = t[0].Total.toFixed(num);
			   		  }   		
			   			
			   	}
			   });
		   },

			//
			handlePageChange({
				currentPage,
				pageSize
			}) {
				this.tablePage.pageNum = currentPage;
				this.tablePage.pageSize = pageSize;
				this.fnSerchXStables(false);
			},
			formatTime({
				cellValue
			}) {
				let date = new Date(cellValue).toLocaleDateString();
				return date;
			},
			fnStateName(data) {
				this.tableData.zt = data.name;
			},
			fnState() {
				let xTable = this.$refs.xTable;
				let userinfo = this.$fun.GetUserConstant();
				let params = Object.assign({}, userinfo);
				if (!this.$refs.xTable.getRadioRecord()) {
					this.$Message.error("未选择任何单据");
					return;
				}
				// if(params.FieldValue == "未执行"){
				// 	params.FieldValue = "-1"
				// }else if(params.FieldValue == "执行中"){
				// 	params.FieldValue = "0"
				// }else if(params.FieldValue == "审核中"){
				// 	params.FieldValue = "1"
				// }else{
				params.FieldValue = "2";
				// }
				params.SerialNo = this.$refs.xTable.getRadioRecord().SerialNo;
				return new Promise((resolve) => {
					setTimeout(() => {
						this.$Api.ErpSetDBPiaoIsCheck(params).then((res) => {
							if (res.status == "SUCCESS") {
								// xTable.updateData()	;
								this.$Message.success(res.msg);
								this.fnSerchXStables(true);
								this.clearRadioRowEevnt();
								resolve();
							} else {
								this.$Message.error(res.msg);
							}
						});
					}, 1);
				});
			},
			fnFState() {
				let xTable = this.$refs.xTable;
				let userinfo = this.$fun.GetUserConstant();
				let params = Object.assign({}, userinfo);
				if (!this.$refs.xTable.getRadioRecord()) {
					this.$Message.error("未选择任何单据");
					return;
				}
				
				params.SerialNo = this.$refs.xTable.getRadioRecord().SerialNo;
				return new Promise((resolve) => {
					setTimeout(() => {
						this.$Api.ErpSetDBPiaoUnCheck(params).then((res) => {
							if (res.status == "SUCCESS") {
								// xTable.updateData()	;
								this.$Message.success(res.msg);
								this.fnSerchXStables(true);
								this.clearRadioRowEevnt();
								resolve();
							} else {
								this.$Message.error(res.msg);
							}
						});
					}, 1);
				});
			},
			radioChangeEvent({
				row
			}) {
				this.selectRow = row;
				console.log("单选事件");
			},
			clearRadioRowEevnt() {
				this.selectRow = null;
				this.$refs.xTable.clearRadioRow();
			},
			abandon(row) {
				let userinfo = this.$fun.GetUserConstant();
				let params = Object.assign({}, userinfo, this.abandonInfo);
				params.SerialNo = row.SerialNo;
				params.FieldValue = "1";
				this.$XModal.confirm("确认作废调拨单吗？").then((type) => {
					if (type === "confirm") {
						this.$Api.ErpSetDBPiaoIsDelete(params).then((res) => {
							if (res.status === "SUCCESS") {
								this.$XModal.message({
									message: res.msg,
									status: "success"
								});
							}
						});
					}
				});
				this.$refs.xTable.updateData();
			},
		},
	};
</script>

<style lang="less" scoped>
	@title_height: 65px;

	.SHPiao {
		width: 100%;
		height: 100%;

		.content {
			width: 100%;
			height: 100%;
			display: flex;
			//background: #1890FF;
			//justify-content: center;
			align-items: center;
			flex-direction: column;
			background: #fff;
			margin: 5px;

			.content-header {
				width: 100%;
				//height: 50px;
				display: flex;
				align-items: center;
				justify-content: center;
				background: #f2f2f2;
				flex-direction: column;

				.title {
					width: 90%;
					padding: 10px 0;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 16px;
					//background: yellow;
				}

				.title-list {
					//height: 200px;
				}
			}

			.center-box {
				width: 100%;
				height: 100%;
				display: flex;
				flex-direction: column;

				//background: #006680;
				.center-top {
					width: 100%;

					.rowitem {
						width: 100%;
						display: flex;
						font-size: 16px;
						flex-wrap: wrap;
						border-bottom: 1px solid rgba(206, 207, 207, 1);

						.inputitem {
							float: left;
							width: 19%;
						}
					}
				}

				.content-bottom {
					height: 50px;
					width: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					margin-top: 0px;
				}

				.center-table {
					width: 100%;
					flex: 1;
max-height: 31.25rem;
					.table-wrap {
						width: 100%;
						height: 100%;
						display: flex;
						flex-direction: column;
						//background: #006680;
					
					}
				}
			}
		}
	}

	.title {
		width: 100%;
	}

	.title>p {
		padding: 10px 20px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 600;
		color: rgba(51, 51, 51, 1);
		overflow: hidden;
		text-align: center;
	}

	.title>p>span {
		width: 38px;
		height: 7px;
		background: rgba(34, 116, 200, 1);
		display: block;
	}
</style>
